// core
import React from "react";
import NumberFormat from "react-number-format";
import useLightwindow from "../../../common/hooks/useLightwindow";

// components
import Icon from "../Icon/Icon";

// styles
import styles from "./Cashback.module.scss";
import cx from "classnames";

type CashbackProps = {
    cashbackAmount: number;
    className?: string;
};

const Cashback: React.FC<CashbackProps> = (props) => {
    const { cashbackAmount, className } = props;

    const { openCashbackModal } = useLightwindow();

    return (
        <div
            className={cx(
                styles["cashback-container"],
                "padding-ml",
                "layout-flex-row--centered",
                "text-font-size-s",
                {
                    [className]: !!className
                }
            )}>
            {/* Title */}
            <div className={cx("text-bold", "space-m", "layout-flex-row--centered")}>
                <Icon id="Cashback" className="space-m" />
                Your Cashback!
            </div>
            {/* Details */}

            <a onClick={openCashbackModal}>View details</a>

            {/* Value */}
            <NumberFormat
                value={cashbackAmount}
                prefix={"+ $"}
                displayType={"text"}
                thousandSeparator
                isNumericString
                decimalScale={2}
                fixedDecimalScale
                className={cx("text-bold", "text-brand", "space-pre-auto")}
            />
        </div>
    );
};

export default Cashback;
